import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./frotas.component.html')
})
export class FrotasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frotas.component.ts
 **/